<template>
  <v-select
    v-model="currentLocale"
    :items="locales"
    class="locale-switch"
    hide-details
    dark
    @change="changeLocale"
  />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LocaleSwitch',
  data: (vm) => ({
    locales: [
      'en',
      'ru',
    ],
    currentLocale: vm.$i18n.locale,
  }),
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async changeLocale(locale) {
      localStorage.setItem('locale', locale);
      this.$moment.locale(locale);
      // this.$http.defaults.headers['x-user-locale'] = locale;
      this.$vuetify.lang.current = locale;
      this.$i18n.locale = locale;

      if (this.user) {
        await this.$http.put(`users/${this.user.id}`, {
          language: locale,
        });

        const { data: userData } = await this.$http.get('main/getself');
        await this.$store.commit('setUser', userData);
      }

      this.$router.go();
    },
  },
};
</script>

<style lang="scss" scoped>
.locale-switch {
  width: 80px;
}
</style>
